export default {
  pickup: 'Nouto',
  delivery: 'Toimitus',
  ongoing_order: 'Käynnissä oleva tilaus',
  view_more: 'Napauta nähdäksesi tiedot',
  status: {
    rejected: {
      title: 'Tilaus hylätty',
      description: 'Napauta nähdäksesi tiedot',
    },
    created: {
      description: 'Tilaus vastaanotettu',
    },
    reviewed: {
      description: 'Tilauksesi on nähty',
    },
  },
  order_type: {
    pickup: 'nouto',
    delivery: 'toimitus',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Tilauksesi on nähty',
    order_confirmed: '#{{number}} Vahvistettu aika {{time}}',
    order_preparation_up_time_changed: '#{{number}} {{type}}-aika muutettu ajaksi {{time}}',
    order_preparing: 'Tilaustasi #{{number}} valmistetaan',
    order_rejected: '#{{number}} tilaus hylätty',
  },
  error_messages: {
    failed_to_load: 'Jokin meni pieleen, yritä uudelleen.',
  },
};
